import API from "../../services/api";

export function listBankCodesForTemplates() {
  return API.get("/banking/templates/bank-codes").then((r) => r.data);
}

export function listTemplates(params = {}) {
  return API.get("/banking/templates", { params }).then((r) => r.data);
}

export function getTemplate(templateId) {
  return API.get(`/banking/templates/${templateId}`).then((r) => r.data);
}

export function createTemplate(payload) {
  return API.post("/banking/templates", payload).then((r) => r.data);
}

export function updateTemplate(templateId, payload) {
  return API.put(`/banking/templates/${templateId}`, payload).then((r) => r.data);
}

export function replaceTemplateColumns(templateId, columns) {
  return API.post(`/banking/templates/${templateId}/columns`, columns).then(
    (r) => r.data
  );
}

export function cloneTemplate(templateId) {
  return API.post(`/banking/templates/${templateId}/clone`).then((r) => r.data);
}

export function previewTemplate(templateId, { config = {}, rowCount = 3 } = {}) {
  return API.post(`/banking/templates/${templateId}/preview`, {
    config,
    row_count: rowCount,
  }).then((r) => r.data);
}

export function deactivateTemplate(templateId) {
  return API.delete(`/banking/templates/${templateId}`).then((r) => r.data);
}
